import { FC } from 'react';
import './ScreenCard.scss';
import { ScreenSource } from './ScreenShareChoosePopup';

interface screenCardPropsType{
  data: ScreenSource;
  index: number;
  selectedScreen: string | undefined;
  setSelectedScreen: (val: string) => void;
}

const ScreenCard:FC<screenCardPropsType> = ({data, index, selectedScreen, setSelectedScreen}) => {
  return (
    <div className={`screenCardContainer ${selectedScreen === data?.id ? 'selectedScreen' : ''}`} onClick={() => setSelectedScreen(data?.id)}>
        <img
            src={data?.thumbnailDataURI}
            alt='screen'
            className='screenImageStyle'
        />
        <div className={`screenNameStyle ${selectedScreen === data?.id ? 'selectedScreenName' : ''}`}>
        {index > 0 && <img src={data?.appIconDataURI} className='screenView' alt='appIcon' height={24} width={24}/>}
        <div className='screenName'>{data?.name}</div>
        </div>
    </div>
  )
}

export default ScreenCard